import type { MenuDefinition, MenuEntry, MenuGroup } from '@/shared/layouts/menu/types';
import type { MeMenu, RbacMenuEntry, RbacMenuGroup } from '../types/permissions';

const EMPTY_MENU: MenuDefinition = { tabs: [] };
let currentMenu: MenuDefinition = EMPTY_MENU;

const toMenuEntry = (entry: RbacMenuEntry): MenuEntry =>
  entry.section
    ? { section: entry.section }
    : {
        label: entry.label,
        path: entry.path ?? '',
        ...(entry.icon ? { icon: entry.icon } : {}),
        ...(entry.disabled ? { disabled: true } : {}),
      };

const toMenuGroup = (group: RbacMenuGroup): MenuGroup => ({
  id: group.id,
  label: group.label,
  icon: group.icon ?? '',
  ...(group.path ? { path: group.path } : {}),
  ...(group.disabled ? { disabled: true } : {}),
  ...(group.items.length > 0 ? { items: group.items.map(toMenuEntry) } : {}),
});

const cloneMenu = (menu: MenuDefinition): MenuDefinition => ({
  tabs: menu.tabs.map(tab => ({
    ...tab,
    groups: tab.groups.map(group => ({
      ...group,
      ...(group.items ? { items: group.items.map(entry => ({ ...entry })) } : {}),
    })),
  })),
});

export function readStoredMenu(): MenuDefinition {
  return cloneMenu(currentMenu);
}

export function writeStoredMenu(menu: MeMenu): void {
  currentMenu = {
    tabs: menu.tabs.map(tab => ({
      id: tab.id,
      label: tab.label,
      groups: tab.groups.map(toMenuGroup),
    })),
  };
}

/** Loading, logout, malformed payloads and request failures all hide the menu. */
export function clearStoredMenu(): void {
  currentMenu = EMPTY_MENU;
}

export function resetMenuSnapshot(): void {
  currentMenu = EMPTY_MENU;
}
